import script from "./tab-analysis.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-analysis.vue?vue&type=script&setup=true&lang=js"

import "./tab-analysis.vue?vue&type=style&index=0&id=d2eaeb02&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2eaeb02"]])

export default __exports__